import styled from 'styled-components';

export const Banner = styled.div`
  position: fixed;
  z-index: 69;
  top: calc(var(--top-clear) + 10px);
  left: 12px;
  right: 12px;
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 14px;
  background: #1d2a4a;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .5);
`;

export const Open = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0 10px 12px;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;

  & img {
    width: 36px;
    height: 36px;
    border-radius: 8px;
  }

  & strong, & span {
    display: block;
  }

  & span {
    opacity: .8;
    font-size: .9em;
  }
`;

export const Close = styled.button`
  align-self: stretch;
  padding: 0 14px;
  border: 0;
  background: none;
  color: inherit;
  font-size: 1.2em;
  cursor: pointer;
`;
